module.exports = __webpack_public_path__ + "img/res07.99e02702.png";